var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 20.05 20.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ada8652a-a7be-418f-8cb0-88727b01652d{fill:none;stroke:#fff;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b2e5fa0a-7712-4ef2-b360-4bd298873632",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b557d336-1694-423c-ae5e-8dbcd0f2b3f8",
    "data-name": "Plus"
  }, /*#__PURE__*/React.createElement("line", {
    id: "aad794bc-948c-4f37-badf-c1181f5cbc48",
    "data-name": "Line 3",
    className: "ada8652a-a7be-418f-8cb0-88727b01652d",
    x1: 19.28,
    y1: 0.52,
    x2: 0.76,
    y2: 19.52
  }), /*#__PURE__*/React.createElement("line", {
    id: "b7ba3a9b-0c2b-4fdc-bb86-6189ba3c4fea",
    "data-name": "Line 6",
    className: "ada8652a-a7be-418f-8cb0-88727b01652d",
    x1: 19.52,
    y1: 19.28,
    x2: 0.52,
    y2: 0.76
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.6dac4bea2d5f43bb87c1f6793a79680b.svg";
export { ForwardRef as ReactComponent };